export function hasField(object, fieldNamePredicate) {
    if (!object) {
        return false;
    }
    if (Array.isArray(object)) {
        return object.some((ele) => hasField(ele, fieldNamePredicate));
    }
    if (typeof object === 'object') {
        const keys = Object.keys(object);
        return keys.some((k) => fieldNamePredicate(k) || hasField(object[k], fieldNamePredicate));
    }
    return false;
}
//# sourceMappingURL=field-key-utils.js.map